module.exports = __webpack_public_path__ + "static/img/woman_glove_2.b4ac2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_2.png
// module id = gdP9
// module chunks = 0